import {WixSdk} from '@wix/js-sdk-wrapper';

export const getSiteOwnerId = () => {
  return WixSdk.Utils.getInstanceValue('siteOwnerId');
};
